const RespWeb = {
	size: function () {
		const w = window.innerWidth;
		if (w <= 440) {
			return 'small';
		} else if (w <= 880) {
			return 'medium';
		}
		return 'large';
	},

	height: function () {
		const h = window.innerHeight;
		if (h <= 600) {
			return 'short';
		} else if (h <= 960) {
			return 'tall';
		}
		return 'extraTall';
	},

	small: function () {
		return this.size() === 'small';
	},

	medium: function () {
		return this.size() === 'medium';
	},

	large: function () {
		return this.size() === 'large';
	},

	// Make sure the size is at least medium
	mediumOrLess: function () {
		return this.size() !== 'large';
	},

	desktop: function () {
		return window.innerWidth >= 880;
	},

	short: function () {
		return this.height() === 'short';
	},

	tall: function () {
		return this.height() === 'tall';
	},

	extraTall: function () {
		return this.height() === 'extraTall';
	},

	// return bounding points for loading popups
	// Not in use
	top_left: function () {
		return this.mediumOrLess() ? new mapboxgl.Point(50, 75) : new mapboxgl.Point(350, 150);
	},
	bottom_right: function () {
		return this.mediumOrLess() ? new mapboxgl.Point(5, 5) : new mapboxgl.Point(50, 150);
	},

	/**
	 * Set map menu collapse state
	 */
	setMapMenu: function () {
		const menuCollapse = document.querySelector('.menu-collapse');
		const mapMenu = document.querySelector('.map-menu');
		const mobileButton = document.querySelector('.map-mobile-menu-button-bar');

		if (this.desktop()) {
			mapMenu.classList.remove('collapsed');
			menuCollapse.classList.remove('opened');
			menuCollapse.setAttribute('aria-hidden', false);
			mobileButton.setAttribute('aria-expanded', false);
		} else {
			if (!menuCollapse.classList.contains('opened')) {
				mapMenu.classList.add('collapsed');
				menuCollapse.setAttribute('aria-hidden', true);
			}
		}
	},

	// Determine if we're SSL
	isSSL: function () {
		return /^https/i.test(location.protocol);
	},
};

export default RespWeb;
